<!-- 图片滑动组件：带标题头+按钮+一屏幕多元素 -->
<template>
<div class="content-block">
  <div class="info-list-title" v-if="showTitle" style="margin-bottom: 0px;">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <!--totalPage:<label>{{totalPage}}</label>|pageY=<label>{{pageY}}</label>|count=<label>{{count}}</label>|total=<label>{{total}}</label>|当前页=<label>{{currentIndex}}</label>-->
    <a href="#" v-if="showMore">更多</a>
  </div>
  <div class="info-list-act" v-if="showAct">
    <a class="list-act-bt01">申请入驻</a>
  </div>
  <div class="info-list-content">
    <div class="no-record-1" v-if="infoList.length<1" style="margin-top:80px"></div>
    <div class="img-slide-warp" :style="{'height': warpHeight}" v-if="infoList.length>0">
      <transition-group :name="currentDirection" tag="ul" @after-leave="autoPlay" class="ac_scroll-ul">
        <li v-for="pageNum in totalPage" :key="pageNum" v-show="currentIndex===pageNum" class="ac_scroll-item">
          <div class="ac_scroll-wrap">
            <div v-for="(info,index) in infoList.slice((pageNum-1)*count,pageNum==totalPage?total:pageNum*count)" v-bind:class="['ac_scroll-cell',scrollCellClass(index)]" :style="{'width': celWidth}">
              <component  :is="infoBlock" :info="info" :titleLength="titleLength"/></component>
            </div>
          </div>
        </li>
      </transition-group>
      <a v-bind:class="['button-left',themStyleSet[btStyle]]" @click="handlePre()">&#139</a>
      <a v-bind:class="['button-right',themStyleSet[btStyle]]" @click="handleNext()">&#155</a>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'ImageSlide',
  components:{},
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    showMore: {
      type: Boolean,
      default: false
    },
    showAct: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    warpH:{
      type: String,
      default: '300px'
    },
    col: {
      type: String,
      default: '3'
    },
    count: {
      type: String,
      default: '3'
    },
    colPadding: {
      type: String,
      default: '30'
    },
    btStyle:{
      type:String,
      default:'0'
    },
    infoBlock:{
      type:Object,
      default:function(){return {}}
    },
    infoList:{
      type:Array,
      default:function(){return []}
    }
  },
  data() {
    return {
      warpHeight:this.warpH,
      celWidth: "calc(100%/" + this.col + ")",
      currentIndex:1,
      currentDirection:"right",
      themStyleSet:['btn-them-1','btn-them-2'],
      initParms:{}
    }
  },
  computed: {
    total:function(){
      let y=this.infoList.length;
      return y;
    },
    pageY:function(){
      let y=this.infoList.length%this.count;
      console.log("总页数求余:"+y);
      return y;
    },
    totalPage: function(){
      let that = this;
      let y=that.infoList.length%that.count;
      if(y==0){
        return parseInt(that.infoList.length/that.count);
      }else{
        return parseInt(that.infoList.length/that.count)+1;
      }
    },
    groupList:function(){
      let that = this;
      let gList=new Array();
      if(that.totalPage<1){
        return gList;
      }else if(that.totalPage==1){
        gList.push(that.infoList);
      }else{
        for(i in that.totalPage){
          if(i==that.totalPage-1){
            gList.push(that.infoList.slice(i*that.count,that.infoList.length));
          }else{
            gList.push(that.infoList.slice(i*that.count,(i+1)*that.count));
          }
        }
      }

      console.log("newPageList:"+JSON.stringify(gList));
      return gList;
    }

  },
  created:function(){
    //this.infoList=this.Global.newsListDemo.slice(0,this.count);
    this.queryPage({page:1,pageSize:this.count,title:this.title});
  },
  methods: {
    queryPage:function(params){
      this.initParms=params;
      this.$emit("queryPage",this.initParms);
    },
    scrollCellClass:function(index){
      if((index+1)%this.col==0){
        return 'cell-right'
      }else if((index+1)%this.col==1){
        return 'cell-left'
      }else{
        return 'cell-center'
      }
    },
    handlePre(){
      this.currentIndex--;
      if(this.currentIndex==0){
        //console.log("图片滑动--左移动!--重置index="+this.count);
        this.currentIndex=this.totalPage;
      };
      this.currentDirection="left";
      console.log("图片滑动--左移动!--index="+this.currentIndex);
    },
    handleNext(){
      this.currentIndex++;
      if(this.currentIndex>this.totalPage){
        //console.log("图片滑动--右移动!--重置index="+this.totalPage);
        this.currentIndex=1;
      };
      this.currentDirection="right";
      console.log("图片滑动--右移动!--index="+this.currentIndex);
    },
    autoPlay(){
      console.log("图片滑动自动播放!");
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-slide-warp{
  position:relative;
  //background:yellow;
}
ul {
  display:block;
  position:relative;
  width:100%;
  height:100%;
  list-style-type: none;
  padding:0px;
  //background:red;
  overflow:hidden;
}

li {
  position:absolute;
  float:left;
  margin: 0px 0px 0px 0px;
  padding:0px;
  height:300px;
  width:100%;
  text-align:left;
  //background:green;
  background-size: auto 300px;
  background-repeat: no-repeat;
  background-position:center center;
}

.cell-left{
  padding-left:0px;
  padding-right:10px;
}
.cell-right{
  padding-left:10px;
  padding-right:0px;
}
.cell-center{
  padding-left:5px;
  padding-right:5px;
}

.list-act-bt01{
  display:block;
  float:left;
  height:30px;
  width:100px;
  padding:0px;
  margin:15px 15px 15px 0px;
  background:var(--color6);
  font-size:12px;
  line-height:30px;
  text-align:center;
  color:#fff;
  cursor: pointer;
  border-radius:15px;
}

.ac_scroll-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content:left;
}

.ac_scroll-cell {
  position:relative;
  box-sizing: border-box;
  height: 100%;
  background: #red;
  border: 0px solid red;
}

.button-left{
  display:block;
  position:absolute;
  left:-50px;
  top: calc(50% - 15px);

}
.button-right{
  display:block;
  position:absolute;
  right:-50px;
  top: calc(50% - 15px);
}

.btn-them-1{
    background:#8a8a8a;
    color: #ffffff;
    height:30px;
    width:30px;
    cursor: pointer;
    font-size: 30px;
    line-height:25px;
    border-radius:15px;
}

.btn-them-2{
    color: #515151;
    height:30px;
    width:30px;
    cursor: pointer;
    font-size: 50px;
    line-height:25px;
}

/** 滚动动画 */
.left-enter {
    transform: translateX(100%) translateY(0);
}

.left-enter-to {
    transition: all 1s ease;
    transform: translateX(0) translateY(0);
}

.left-leave {
    transform: translateX(0) translateY(0);
}

.left-leave-active {
    transition: all 1s ease;
    transform: translateX(-100%)
}


.right-enter {
    transform: translateX(-100%) translateY(0);
}

.right-enter-to {
    transition: all 1s ease;
    transform: translateX(0) translateY(0);
}

.right-leave {
    transform: translateX(0) translateY(0);
}

.right-leave-active {
    transition: all 1s ease;
    transform: translateX(100%)
}

</style>



// WEBPACK FOOTER //
// src/components/block/ImageSlide.vue